import React from 'react';

interface IAjaxContext {
	getData: ({
		endpoint,
		customHeaders,
		queryParams,
		timeout
	}: {
		endpoint: any;
		customHeaders?: any;
		queryParams?: any;
		timeout?: any;
	}) => any;
	postData: ({
		endpoint,
		customHeaders,
		queryParams,
		timeout,
		body,
		baseUrlFromParams,
		returnResponse
	}: {
		endpoint: any;
		customHeaders?: any;
		queryParams?: any;
		timeout?: any;
		body?: any;
		baseUrlFromParams?: string;
		returnResponse?: boolean;
	}) => any;
	putData: ({
		endpoint,
		customHeaders,
		queryParams,
		timeout,
		body,
		baseUrlFromParams
	}: {
		endpoint: any;
		customHeaders?: any;
		queryParams?: any;
		timeout?: any;
		body?: any;
		baseUrlFromParams?: string;
	}) => any;
}

const AjaxContext = React.createContext<IAjaxContext>({} as IAjaxContext);

export default AjaxContext;
